
import { defineComponent, PropType } from 'vue'
import { IssueSeverityFilter, SeverityFilterChoice, severityFiltersList } from '~/types/issues'

export default defineComponent({
  name: 'SeverityFilter',

  props: {
    selectedSeverityFilter: {
      type: String as () => IssueSeverityFilter,
      default: ''
    },
    direction: {
      type: String as PropType<'left' | 'right'>,
      default: 'right'
    }
  },

  emits: ['update-severity-filter', 'menu-toggle'],

  data() {
    return {
      severityFiltersList
    }
  },

  computed: {
    filterApplied(): boolean {
      return Boolean(this.selectedSeverityFilter)
    },

    appliedFilter(): SeverityFilterChoice | null {
      return this.severityFiltersList.find(({ key }) => key === this.selectedSeverityFilter) ?? null
    }
  },

  methods: {
    computedClasses(isOpen: boolean): string {
      if (this.appliedFilter) {
        return 'bg-ink-200 hover:bg-ink-100'
      }

      if (isOpen) {
        return 'border-dashed bg-ink-200 text-vanilla-100'
      }

      return 'border-dashed text-vanilla-400 hover:text-vanilla-100'
    }
  }
})
